import { customerPortal } from "@vilocnv/allsetra-core";
import axiosInstance from "app/axiosInstance";

type GetGeozonesRequestDto = customerPortal.geozones.GetGeozonesRequestDto;

export const getGeozones = async (payload: GetGeozonesRequestDto) => {
  try {
    const { accountId } = payload;
    const response = await axiosInstance.get(`/accounts/${accountId}/geozones`);

    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
